// This is a magic string replaced by rollup

const SDK_VERSION = "9.42.1" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
